import React from "react";
import {Modal, ScrollView, View} from "react-native";
import MainStyle from "../../MainStyle";
import Div from "../lib/Div";
import P from "../lib/P";
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons";
import Btn from "../components/Btn";

type Props = {
  visible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

/**
 * ConfirmShotModal — the per-SHOT confirmation POP-UP (Single Shot / on_shot,
 * SMG-3481 gesture; SMG-3970 pop-up).
 *
 * #949 shipped the per-shot confirm as an INLINE button only, so a Single Shot
 * player got a small "Confirm your shot" check button instead of the prominent,
 * unmissable pop-up the per-TURN confirmation gets (ActivePlayerConfirmationModal).
 * QA read that as "no confirmation pop-up". This restores parity: when the
 * per-shot confirm is owed, present it as a modal that looks nearly identical to
 * the per-turn modal.
 *
 * Purely presentational — the confirm action (confirmShot ->
 * RespondToConfirmation(accepted=true), which arms shot_armed_bet_id) and the
 * cancel action (CancelBet) live in FullSwingHomePage and are passed in. The
 * confirm button keeps testID="confirm-shot-btn" so existing callers/tests that
 * drive the per-shot arm are unaffected by the inline→pop-up change.
 */
const ConfirmShotModal = ({visible, onConfirm, onCancel}: Props) => (
  <Modal animationType="fade" transparent visible={visible} statusBarTranslucent={false}
         hardwareAccelerated={false} onRequestClose={onCancel}>
    <View style={[MainStyle.fix_gradient_and_modal_error_in_landscape, MainStyle.flex1, MainStyle.bg_filter_modal]}>
      <ScrollView contentContainerStyle={MainStyle.flex1}>
        <Div minH="100%" alignItems="center" justifyContent="center">
          <Div testID="confirm-shot-modal" bg="#131314" w={343} rounded={16} overflow="hidden">
            <Div position="relative" bg="#252526" justifyContent="center">
              <P fontFamily="DavisSans-Medium" ta="center" lh={48}>Confirm Your Shot</P>
            </Div>

            <Div px={16} pb={16} pt={40} alignItems="center">
              <Div position="relative" mb={15}>
                <MaterialCommunityIcons name="check-circle" size={48} color="#1E9428"/>
                <Div position="absolute" top={10} right={10} bottom={10} left={10} bg="white" zIndex={-1}/>
              </Div>

              <P fontFamily="DavisSans-Regular" ta="center" mb={20}>
                Tap below to confirm your shot!
              </P>
              <Btn testID="confirm-shot-btn" bg="#3369FF" onPress={onConfirm} w="100%">
                <P fontFamily="DavisSans-Medium" lh={56} ta="center">Confirm Your Shot</P>
              </Btn>
              <Btn mt={12} onPress={onCancel}>
                <P fontFamily="DavisSans-Regular" color="#BBBCBF"
                   textDecorationLine="underline">Cancel</P>
              </Btn>
            </Div>
          </Div>
        </Div>
      </ScrollView>
    </View>
  </Modal>
);

export default ConfirmShotModal;
